import React from 'react';
import axios from 'axios';
import { DateTimePicker } from 'react-widgets';
import { Button, Form, Grid, Icon, Label, Popup, Segment, Table } from 'semantic-ui-react';
import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-widgets/dist/css/react-widgets.css';
import 'react-datepicker/dist/react-datepicker.css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

momentLocalizer(moment);
// props: templateId, facultyId
export default class CreateConfig extends React.Component {
    // study program id and template id is injected via props
    constructor(props) {
        super(props);
        this.state = {
            startDate: new Date(),
            startDateErr: false
        };
        this.handleDateChange = this.handleDateChange.bind(this);
        this.addNewConfig = this.addNewConfig.bind(this);
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    /**
     * Returns true when archiving (deactivating) a template configuration row should be prevented.
     *
     * Student-service context: diploma-related templates (IDs 1 & 2) must not be archived.
     * Admin / OU context: student-service-specific templates (IDs 3-6) must not be archived.
     */
    isArchiveDisabled(el) {
        if (this.props.studentService) {
            return el.templateId === 1 || el.templateId === 2;
        }
        return el.templateId === 3 || el.templateId === 4 || el.templateId === 5 || el.templateId === 6;
    }

    addNewConfig() {
        const { startDate } = this.state;
        if (!startDate) {
            toast('Niste unijeli datum početka!');
            this.setState({ startDateErr: true });
        } else {
            this.setState({ startDateErr: false });
            const {
                faculty, studyProgram, scope, template,
            } = this.props;
            const configObject = { templateId: template, useStart: moment(this.state.startDate).format() };

            let url;
            if (this.props.studentService) {
                url = '/template-configuration/add';
            } else if (scope === 'sp') {
                if (!studyProgram) {
                    toast('Odaberite studijski program.');
                    return;
                }
                url = `/template-configuration/add/study-program/${studyProgram}`;
            } else {
                if (!faculty) {
                    toast('Odaberite fakultet.');
                    return;
                }
                url = `/template-configuration/add/${faculty}`;
            }

            axios.post(url, configObject)
                .then(() => {
                    this.setState({ startDate: new Date() });
                    this.props.changeStep(true);
                })
                .catch(err => {
                    if (err.response && err.response.data && err.response.data.code === 'DUPLICATE_ACTIVE_CONFIGURATION') {
                        toast('Aktivna konfiguracija za odabrani nivo i dokument već postoji.');
                    } else if (err.response && err.response.data === 'Valid template already exists!') {
                        toast('Konfiguracija već postoji! Nova nije kreirana.');
                    } else {
                        toast('Došlo je do greške! Konfiguracija nije kreirana.');
                    }
                    this.props.changeStep(false);
                });
        }
    }
    render() {
        return (
            <div>
                <Segment.Group secondary>
                    <Segment secondary clearing>
                        <Form noValidate>
                            {!this.props.studentService && <Grid centered className="stackable">
                                <Grid.Row >
                                    <Grid.Column>
                                        <Form.Field>
                                            <label htmlFor="facultySelect">Fakultet</label>
                                            <Form.Select
                                                name={this.props.nameF}
                                                id="facultySelect"
                                                value={this.props.valueF}
                                                onChange={this.props.onChangeF}
                                                options={this.props.dataF}
                                                search
                                            />
                                        </Form.Field>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>}
                            <Grid columns={2} centered className="stackable">
                                <Grid.Row stretched>
                                    <Grid.Column>
                                        <Form.Field>
                                            <label htmlFor="templateSelect" color="black">{this.props.simpleName}</label>
                                            <Form.Select
                                                name={this.props.name}
                                                id="templateSelect"
                                                value={this.props.value}
                                                onChange={this.props.onChange}
                                                options={this.props.data}
                                                search
                                                fluid
                                            />
                                        </Form.Field>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form onSubmit={(e) => { e.preventDefault(); }}>
                                            <Form.Field required error={this.state.startDateErr}>
                                                <label htmlFor="startDatePicker">Datum početka</label>
                                                <DateTimePicker
                                                    id="startDatePicker"
                                                    format="D .M. YYYY."
                                                    defaultValue={new Date()}
                                                    time={false}
                                                    onChange={this.handleDateChange.bind(null, 'startDate')}
                                                    value={this.state.startDate}
                                                />
                                            </Form.Field>
                                        </Form>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <br />

                            {/* <Button floated="right" color="blue" basic="true"onClick={() => this.props.changeStep()}>Odustani</Button> */}
                            <Button floated="right" color="blue" onClick={() => this.addNewConfig()}>Dodaj</Button>
                        </Form>
                    </Segment>
                </Segment.Group>

                {this.props.templateConfigs.length ? <Table celled selectable compact >
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan="2">Tip dokumenta</Table.HeaderCell>
                            <Table.HeaderCell>Datum početka korištenja</Table.HeaderCell>
                            <Table.HeaderCell>Datum kraja korištenja</Table.HeaderCell>
                            <Table.HeaderCell />
                        </Table.Row>
                    </Table.Header>

                    <Table.Body> {this.props.templateConfigs.sort((a, b) => a.useEnd - b.useEnd).map((el, index) =>
                        (<Table.Row key={index}>
                            <Table.Cell verticalAlign="middle" colSpan="2">
                                {el.name}
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                {moment(el.useStart).format('D. M. YYYY.')}
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                {el.useEnd !== null ? moment(el.useEnd).format('D. M. YYYY.') : '-'}
                            </Table.Cell>
                            <Table.Cell textAlign="center" verticalAlign="middle">
                                {el.useEnd === null ?
                                    <Popup
                                        content="Arhiviranje konfiguracije"
                                        position="top center"
                                        trigger={
                                            <Button
                                                disabled={this.isArchiveDisabled(el)}
                                                basic="true"
                                                circular
                                                icon="archive"
                                                size="small"
                                                color="red"
                                                onClick={() => this.props.deleteConfig(el.organizationalUnitTemplateConfigurationId)}
                                            />}
                                    /> :
                                    <span> <Label prompt color="grey" basic> <Icon name="attention" /> arhivirano</Label></span>
                                }
                            </Table.Cell>
                        </Table.Row>))}
                    </Table.Body>
                </Table>
                    : <p>Nema unesenih podataka o konfiguraciji.</p>}

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/DocumentTemplateConfiguration/CreateConfig.js